module.exports = __webpack_public_path__ + "static/media/Card-White.fddeff18.png";